<template>
    <div>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#settlements" @click="gotoTab(1)">
                                {{ $t('label.settlements') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#sent_files" @click="gotoTab(2)">
                                {{ $t('settlement.sent_files') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#received_files" @click="gotoTab(3)">
                                {{ $t('settlement.received_files') }}
                            </a>
                        </li>
                    </ul>
                    <div class="button-group dropleft" v-if="$can('manage', 'all')">
                        <button class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown">
                            {{ $t('label.requests') }}
                        </button>
                        <div class="dropdown-menu">
                            <button @click="requestScriptSettlement('upload')" class="dropdown-item btn-dark my-1">
                                {{ $t('label.upload_settlement_file')}}
                            </button>
                            <button @click="requestScriptSettlement('downloadUploaded')"  class="dropdown-item btn-info my-1">
                                {{ $t('label.download_file_uploaded')}}
                            </button>
                            <button @click="requestScriptSettlement('download')" class="dropdown-item btn-instagram my-1">
                                {{ $t('label.download_result_answer')}}
                            </button>
                            <button @click="requestScriptSettlement('checkSettlementUpload')" class="dropdown-item btn-warning my-1">
                                {{ $t('label.check_settlement_uploaded')}}
                            </button>
                        </div>
                    </div>


                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                        <manage-access-filter :action="filterAction" :exportExcel="exportToExcel"></manage-access-filter>
                        <div class="switch-div">
                            تسویه های دستی
                            <label class="switch m-0 mr-2 ml-2">
                                <input id="settlement_checkbox" type="checkbox" @change="checkbox_changed">
                                <span class="slider round"></span>
                            </label>
                            تمام تسویه ها
                        </div>
                        <div class="switch-div mt-2">
                            تسویه های پرداختیاری
                            <label class="switch m-0 mr-2 ml-2">
                                <input id="settlement_source_checkbox" type="checkbox" v-model="isDirect" @change="sourceChanged">
                                <span class="slider round"></span>
                            </label>
                            تسویه های مستقیم
                        </div>
                        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                    </div>
                    <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">
                        <kt-row class="text-center">
                            <kt-col v-bind:key="index"
                                    v-for="(data, index) in files.sent"
                                    xs="12" md="3"
                            >
                                <button :id="'settlement_'+index" @click="export_settlement($event, data.date,index)"  class="btn btn-sm btn-clean btn-icon btn-icon-sm text-success special-tooltip mx-1">
                                    <span class="tooltip-text" >{{ $t('reports.btn.export_files') }}</span>
                                    <i class="far fa-file-excel fa-2x" style="color: #1D6F42;height: fit-content"></i>
                                </button>
                                <a class="btn btn-outline-dark mb-1 mt-1 mx-2 " v-bind:href="data.url">
                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                </a>
                            </kt-col>
                        </kt-row>
                    </div>
                    <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
                        <div class="accordion accordion-toggle-arrow" id="accordion_one">
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseOne" aria-controls="collapseOne">
                                            <i class="fa fa-file-alt" aria-hidden="true"></i>
                                            {{ $t('label.settlement_responses') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion_one">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.received"
                                                    xs="12" md="3"
                                            >
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code  " aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion accordion-toggle-arrow" id="accordion_two">
                            <div class="card">
                                <div class="card-header" id="headingTwo">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-controls="collapseTwo">
                                            <i class="fa fa-chart-bar" aria-hidden="true"></i>
                                            {{ $t('label.settlement_switch') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion_two">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.switch"
                                                    xs="12" md="3"
                                            >
                                                <button :id="'settlement_switch'+index" @click="settlement_switch($event, data.date,index)" class="btn btn-sm btn-clean btn-icon btn-icon-sm  special-tooltip mx-1">
                                                    <span class="tooltip-text"> {{ $t('reports.btn.export_files') }}</span>
                                                    <i class="far fa-file-excel fa-2x " style="color: #1D6F42;height: fit-content"></i>
                                                </button>
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion accordion-toggle-arrow" id="accordion_three">
                            <div class="card">
                                <div class="card-header" id="headingThree">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseThree" aria-controls="collapseThree">
                                            <i class="fa fa-credit-card"></i>
                                            {{ $t('label.settlement_announcement') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion_three">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.announcement"
                                                    xs="12" md="3"
                                            >
                                                <button :id="'settlement_announcement'+index" @click="settlement_announcement($event, data.date,index)" class="btn btn-sm btn-clean btn-icon btn-icon-sm  special-tooltip mx-1">
                                                    <span class="tooltip-text"> {{ $t('reports.btn.export_files') }}</span>
                                                    <i class="far fa-file-excel fa-2x " style="color: #1D6F42;height: fit-content"></i>
                                                </button>
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </div>
</template>

<script>
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import manageAccessFilter from './manage-access-filter'
import columns from "../datatable/columns";
import actions from "../datatable/actions";
import $ from 'jquery'
import axios from "axios";
import { KTApp } from '@/plugins/core/app'
import toastr from "toastr";
import {mapGetters} from "vuex"
export default {
    components: {
        manageAccessFilter
    },
    data() {
        return {
            isLoding:[],
            currentTab: 1,
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {},
            isDirect: false,
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
        ...mapGetters('settlement', [
            'files'
        ]),
        datatableProps() {
            return {
                id: "settlement_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path(this.isDirect ? 'settlement/admin/psp-settlements' : 'settlement/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                if (this.isDirect) {
                                    return res.data.data.map(row => ({...row, is_direct: true}))
                                }
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    saveState: {
                        cookie: false,
                    }
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        },

    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('settlement_manage_access_active_tab');
            this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
        }
        this.$store.dispatch('settlement/fetchFiles')
    },
    methods: {
        requestScriptSettlement(type) {
            this.$store.dispatch('settlement/requestSettlementScript', type)
                .then(({data}) => {
                    this.toastr.success(data.data.message)
                }).catch(({response})=> {
                    this.toastr.error(response.data.message)
                })

        },
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('settlement_manage_access_active_tab', selectedTab);
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        settlement_announcement(e, query, index){
            let btn = $('#settlement_announcement'+index)
            KTApp.progress(btn);
            btn.css("backgroundColor", "#1D6F42");
            this.query = query
            axios({
                url: ApiUrl.path(`settlement/export_settlement_announcement`),
                method: 'GET',
                params: {
                    date : this.query
                },
                headers: {
                    "Content-Disposition": "attachment;filename=report.xls",
                    "Content-type": "application/vnd.ms-excel",
                },
        }).then((response) => {
                var fileLink = document.createElement('a');
                fileLink.href = response.data;
                fileLink.setAttribute('download', 'settlement_announcement.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(response.data.message);
            }).finally(() => {
                KTApp.unprogress(btn)
                btn.css("backgroundColor", "transparent")
            });
        },
        settlement_switch(e, query,index){
            let btn = $('#settlement_switch'+index)
            KTApp.progress(btn);
            btn.css("backgroundColor", "#1D6F42");
            this.query = query
            axios({
                url: ApiUrl.path(`settlement/export_settlement_switch`),
                method: 'GET',
                params: {
                    date : this.query
                },
                headers: {
                    "Content-Disposition": "attachment;filename=report.xls",
                    "Content-type": "application/vnd.ms-excel",

                },

            }).then((response) => {
                KTApp.unprogress(btn);
                btn.css("backgroundColor", "transparent")
                var fileLink = document.createElement('a');
                fileLink.href = response.data;
                fileLink.setAttribute('download', 'settlement_switch.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(response.data.message);
                KTApp.unprogress(btn)
                btn.css("backgroundColor", "transparent")
            })
        },
        export_settlement(e, query,index){
            let btn = $('#settlement_'+index)
            KTApp.progress(btn);
            btn.css("backgroundColor", "#1D6F42");
            this.query = query
            axios({
                url: ApiUrl.path(`settlement/export_settlement`),
                method: 'GET',
                params: {
                    date : this.query
                },

            }).then((response) => {
                KTApp.unprogress(btn);
                btn.css("backgroundColor", "transparent");
                var fileLink = document.createElement('a');
                fileLink.href = response.data;
                fileLink.setAttribute('download', 'settlement.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(response.data.message);
                KTApp.unprogress(btn)
                btn.css("backgroundColor", "transparent")

            })
        },
        exportToExcel(e, query){
            this.query = query

            let form = $('#settlement_export_form')
            let btn = $('#settlement_export_btn')
            form.validate({
                rules: {
                    from_date: {
                        required: true,
                    },
                    to_date: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            axios({
                url: ApiUrl.path('settlement/admin/settlements-excel-export'),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", `settlements-${this.query.from_date}-${this.query.to_date}.xlsx`);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    KTApp.unprogress(btn)
                    // KTApp.unprogress(btn)
                    // var fileLink = document.createElement('a');
                    //
                    // fileLink.href = response.data.data;
                    // fileLink.setAttribute('download', 'settlements.xlsx');
                    // document.body.appendChild(fileLink);
                    //
                    // fileLink.click();
                })
                .catch(({response}) => {
                    KTApp.unprogress(btn)
                    this.toastr.error(response.data.message)
                })
        },
        sourceChanged() {
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#settlement_checkbox')

            if (checkbox.is(":checked"))
                this.query.manual_settlements = 1
            else
                this.query.manual_settlements = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style scoped>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>
